<template>
  <div>
    <div class="card-filter-section py-1">
      <div class="d-flex align-items-center flex-wrap justify-content-between">
        <div class="d-flex align-items-center">
          <button class="back-button btn btn-secondary mr-2" @click="back()">
            <feather-icon icon="ArrowLeftIcon" width="18" height="18" />
            <span>Back</span>
          </button>
          <p class="filter-title ml-50">Quarter Resource Report ({{ monthYear }})      
          </p>
        </div>
      </div>
    </div>
    <div>
      <div v-if="resourceLoader">
        <TableLoader :fields="monthly" />
      </div>
      <template v-else>
        <div v-if="totalCount > 0" class="report-view skill-report actual-report-table">
          <TableLoader v-if="resourceLoader" :fields="monthly" />
        <b-table
          v-else
          :fields="monthly"
          :items="Object.keys(monthlyItems)"
          class="resource-user-table d-inline-block"
        >
          <template #cell(name)="data">
            <div class="resource-user-data">
              <div/>

              <div class="resource-user">
                <div class="d-flex align-items-center">
                  <b-avatar
                    :src="
                      monthlyItems[data.item] &&
                      monthlyItems[data.item].length
                        ? monthlyItems[data.item][0].picture
                        : ''
                    "
                    :text="
                      monthlyItems[data.item] &&
                      monthlyItems[data.item].length
                        ? monthlyItems[data.item][0].full_name
                        : '' | avatarText
                    "
                    size="50"
                  />
                </div>
                {{ monthlyItems[data.item][0].full_name }}
              </div>
            </div>
          </template>

          <template #cell(managed_by)="data">
            <div class="resource-user-data">
              <div/>
              <div class="resource-user">
                <div class="d-flex align-items-center" style="min-height: 40px;">
                  {{ monthlyItems[data.item] && monthlyItems[data.item][0] && monthlyItems[data.item][0].manage_by_user
                  ? monthlyItems[data.item][0].manage_by_user.full_name
                  : '-' }}
                </div>
              </div>
            </div>
          </template>

          <template #cell(reporting_to)="data">
            <div class="resource-user-data">
              <div/>
              <div class="resource-user">
                <div class="d-flex align-items-center" style="min-height: 40px;">
                  {{ monthlyItems[data.item] && monthlyItems[data.item][0] && monthlyItems[data.item][0].users
                  ? monthlyItems[data.item][0].users.full_name
                  : '-' }}
                </div>
              </div>
            </div>
          </template>
          
          <template #cell(billable_allocation)="data">
            <div class="plan-project actual-log">
              <div>
                
                <div
                  v-for="(resourcePlan, index) in monthlyItems[data.item][0]
                    .resource_plan"
                  v-if="
                    monthlyItems[data.item][0] &&
                    monthlyItems[data.item][0].resource_plan &&
                    monthlyItems[data.item][0].resource_plan.length &&
                    resourcePlan.is_billable
                  "
                  class="resource-user-project"
                >
                  <div class="resource-project-name">
                    <span
                      v-b-tooltip.hover
                      :title="resourcePlan.project.name">
                      {{ resourcePlan.project.code }}
                    </span>
                    <span
                      :class="
                        resourcePlan.is_billable === 1
                          ? 'text-primary'
                          : 'text-secondary'
                      "
                      class="ml-1"
                      title="Billing status"
                      >$</span
                    >
                  </div>
                  <div class="resource-project-hour">
                    <span
                      >{{
                        resourcePlan.planned_hours
                          ? (
                              (resourcePlan.planned_hours / 160) *
                              100
                            ).toFixed(2)
                          : 0
                      }}%</span
                    >
                    ({{ resourcePlan.planned_hours }})
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template #cell(non_billable_allocation)="data">
            <div class="plan-project actual-log">
              <div>
                <div
                  v-for="(resourcePlan, index) in monthlyItems[data.item][0]
                    .resource_plan"
                  v-if="
                    monthlyItems[data.item][0] &&
                    monthlyItems[data.item][0].resource_plan &&
                    monthlyItems[data.item][0].resource_plan.length && 
                    resourcePlan.is_billable === 0
                  "
                  class="resource-user-project"
                >
                  <div class="resource-project-name">
                    <span
                      v-b-tooltip.hover 
                      :title="resourcePlan.project.name">
                      {{ resourcePlan.project.code }}
                    </span>
                    <span
                      :class="
                        resourcePlan.is_billable === 1
                          ? 'text-primary'
                          : 'text-secondary'
                      "
                      class="ml-1"
                      title="Billing status"
                      >$</span
                    >
                  </div>
                  <div class="resource-project-hour">
                    <span
                      >{{
                        resourcePlan.planned_hours
                          ? (
                              (resourcePlan.planned_hours / 160) *
                              100
                            ).toFixed(2)
                          : 0
                      }}%</span
                    >
                    ({{ resourcePlan.planned_hours }})
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template #cell(total_hours)="data">
            <div class="resource-user-total">
              <span
                :class="monthlyItems[data.item][0].totalHours < 40
                  ? 'text-success'
                  : monthlyItems[data.item][0].totalHours > 119
                    ? 'text-danger'
                    : 'text-warning'
                "
              >
                {{ monthlyItems[data.item][0] && monthlyItems[data.item][0].totalHours ?
                  monthlyItems[data.item][0].percentage : 0 }} %
              </span> ({{ monthlyItems[data.item][0] && monthlyItems[data.item][0].totalHours ?
                monthlyItems[data.item][0].totalHours : 0 }} hrs)
            </div>
          </template>
        </b-table>
        </div>
        <div v-else class="text-center">
          <img
            src="@/assets/images/nodatafound/nodata.svg"
            alt="no-data"
            class="no-data-img"
          >
        </div>

        <div class="pb-1">
          <Pagination
            v-if="totalCount > 0"
            :current-page="currentPage"
            :per-page="perPage"
            :total-count="totalCount"
            @currentPage="handlePageChange"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import TableLoader from "../../components/loaders/table-loading.vue";
import FeatherIcon from "../../@core/components/feather-icon/FeatherIcon.vue";
import QuarterlyResourceReportDetailsMixin from '../../mixin/report/quarterlyReport/quarterlyResourceReportDetails'

export default {
  name: "QuarterResourceReportDetails",

  components: {
    TableLoader,
    FeatherIcon,
  },

  mixins: [QuarterlyResourceReportDetailsMixin],
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/component-css/tesing.css";
@import "../../assets/scss/component-css/vieweditheader.scss";
@import "../../assets/scss/component-css/viewedit.scss";
@import "../../assets/scss/component-css/QuarterlyResourceReport.scss";
</style>
